<template>
  <calculator/>
</template>

<script>
// @ is an alias to /src
import Calculator from '@/components/Calculator.vue'

export default {
  name: 'Home',
  components: {
    Calculator
  },
  head: {
    link: [
      { rel: 'canonical', href: 'https://scientificedibles.com/', id: 'canonical' }
    ]
  },
  metaInfo:{
    title: 'Edibles Calculator'
  }
}
</script>
